import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// 🔐 SECURITY: Configure axios globally for httpOnly cookies
axios.defaults.withCredentials = true;

// Additional error suppression for extension-related errors
const suppressExtensionErrors = () => {
  const extensionKeywords = [
    'Backpack',
    'chrome-extension://',
    'moz-extension://',
    'User rejected the request',
    'MetaMask',
    'Starknet',
    'window.ethereum',
    'code: 4001',
    'has not been authorized yet',
    'extension://',
    'onhogfjeacnfoofkfgppdlbmlmnplgbn',
    'page.js'
  ];

  // Suppress React error boundary for extension errors
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    const errorString = args.join(' ');
    const isExtensionError = extensionKeywords.some(keyword => 
      errorString.includes(keyword)
    );
    
    if (!isExtensionError) {
      originalConsoleError(...args);
    }
  };
};

// Initialize error suppression
suppressExtensionErrors();

// Disable React Error Overlay for extensions
if (process.env.NODE_ENV === 'development') {
  const showErrorOverlay = (err: any) => {
    const errorStr = err?.message || err?.stack || String(err);
    const extensionKeywords = [
      'chrome-extension://',
      'has not been authorized yet',
      'page.js',
      'extension://',
      'onhogfjeacnfoofkfgppdlbmlmnplgbn'
    ];
    
    // Don't show overlay for extension errors
    return !extensionKeywords.some(keyword => errorStr.includes(keyword));
  };

  // Override error overlay
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const errorStr = args.join(' ');
    if (!showErrorOverlay({ message: errorStr })) {
      return; // Suppress extension errors completely
    }
    originalConsoleError(...args);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
